import { render, staticRenderFns } from "./expo_new_detail.vue?vue&type=template&id=4e84b1fa&"
import script from "./expo_new_detail.vue?vue&type=script&lang=js&"
export * from "./expo_new_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports